import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) bottom/ cover no-repeat`}
          column
          justifyBetween
          textCenter
        >
          <Header />
          <CFView pulsate mb="20px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <Header />
        <CFView
          h="95vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) right / cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignEnd
        >
          <CFView column center mr="8%">
            <CFImage
              maxWidth="615px"
              src={heroText}
              alt="Oliv Chicken hero text"
              zIndex={98}
            />
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
